(function () {
  const initSlider = (section) => {
    const sliderEl = section.querySelector(".swiper--custom-slider");

    if (!sliderEl) return;

    const nextBtn = section.querySelector(
      ".heading-group__navigation-button-next"
    );
    const prevBtn = section.querySelector(
      ".heading-group__navigation-button-prev"
    );
    const itemsPerRow = Number(sliderEl.dataset.itemsPerRow || 2);

    const breakpoints = {
      4: {
        576: {
          slidesPerView: 2,
        },
        990: {
          slidesPerView: 3,
        },
        1200: {
          slidesPerView: 4,
        },
      },
      3: {
        576: {
          slidesPerView: 2,
        },
        990: {
          slidesPerView: 3,
        },
      },
      2: {
        576: {
          slidesPerView: 2,
        },
      },
      1: {
        576: {
          slidesPerView: 1,
        },
      },
    };

    new Swiper(sliderEl, {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 800,
      mousewheel: {
        forceToAxis: true,
      },
      watchSlidesProgress: true,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
        disabledClass: "swiper-button-disabled",
      },
      breakpoints: breakpoints[itemsPerRow],
    });
  };

  const destroySlider = (section) => {
    const sliderEl = section.querySelector(".swiper--custom-slider");
    const slides = section.querySelectorAll(".custom-slider__item");

    if (sliderEl?.swiper) sliderEl.swiper.destroy();

    slides.forEach((slide) => {
      slide.removeAttribute("style");
    });
  };

  const initCollectionsGridSwiper = (section) => {
    if (!section || !section?.classList.contains("custom-slider-section")) {
      return;
    }

    const box = section.querySelector(".custom-slider");
    if (!box) return;

    const layout = box.dataset.layoutType || "grid";

    if (layout === "slider") {
      initSlider(box);
    } else {
      destroySlider(box);
    }
  };

  initCollectionsGridSwiper(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initCollectionsGridSwiper(event.target);
  });
})();

/* Curved progress animation */
function initCurveWidget(container) {
  const svg = container.querySelector(".curve-svg");
  const bgPath = svg.querySelector(".curve-bg");
  const progressPath = svg.querySelector(".curve-progress");
  const markersGroup = svg.querySelector(".curve-markers");

  if (!bgPath || !progressPath || !markersGroup) return;

  const length = bgPath.getTotalLength();

  const progress = container.dataset.progress / 100;

  progressPath.style.strokeDasharray = length;
  progressPath.style.strokeDashoffset = length;
  progressPath.style.transition = "none";

  markersGroup.innerHTML = "";

  const points = [0, 0.2, 0.4, 0.6, 0.8, 1];

  points.forEach(p => {
    const point = bgPath.getPointAtLength(length * p);

    if (p !== 0 && p !== 1) {
      const dot = document.createElementNS("http://www.w3.org/2000/svg", "circle");
      dot.setAttribute("cx", point.x);
      dot.setAttribute("cy", point.y - 10);
      dot.setAttribute("r", 1);

     /* if (Math.abs(p - progress) < 0.11) {
        dot.setAttribute("fill", "#000");
        dot.setAttribute("r", 3);
      } else {
        dot.setAttribute("fill", "#aaa");
      }*/

      markersGroup.appendChild(dot);
    }

    if (p === 0 || p === 1) {
      const text = document.createElementNS("http://www.w3.org/2000/svg", "text");
      text.setAttribute("x", point.x);
      text.setAttribute("y", point.y - 15);
      text.setAttribute("text-anchor", "middle");
      text.textContent = p === 0 ? "0" : "100";
      markersGroup.appendChild(text);
    }
  });

  requestAnimationFrame(() => {
    progressPath.style.transition = "stroke-dashoffset 2s ease";
    progressPath.style.strokeDashoffset = length * (1 - progress);
  });
}

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const widget = entry.target;
      if (widget.dataset.animated === "true") return;
      initCurveWidget(widget);
      widget.dataset.animated = "true";
      obs.unobserve(widget);
    });
  }, { threshold: 0.5 });

document.querySelectorAll(".curve-widget").forEach(widget => {
  observer.observe(widget);
});